import { Select } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import type { OsnovaSeznama } from './useSeznam';

/** Obdobje od–do (parametra {@code od}/{@code do} v URL-ju, za API oblika 2026-10-04). */
export function Obdobje({ seznam }: { seznam: OsnovaSeznama }) {
  return (
    <>
      <DatePickerInput
        aria-label="Od"
        placeholder="Od"
        value={seznam.parameter('od')}
        onChange={(v) => seznam.nastavi({ od: v })}
        valueFormat="D. M. YYYY"
        clearable
        w={{ base: 'calc(50% - 6px)', sm: 150 }}
      />
      <DatePickerInput
        aria-label="Do"
        placeholder="Do"
        value={seznam.parameter('do')}
        onChange={(v) => seznam.nastavi({ do: v })}
        valueFormat="D. M. YYYY"
        clearable
        w={{ base: 'calc(50% - 6px)', sm: 150 }}
      />
    </>
  );
}

/** Izbira Vsi / Da / Ne (parameter v URL-ju; za API 0 = vsi, 1 = da, 2 = ne). */
export function DaNe({ seznam, ime, oznaka }: { seznam: OsnovaSeznama; ime: string; oznaka: string }) {
  return (
    <Select
      label={oznaka}
      data={[
        { value: '0', label: 'Vsi' },
        { value: '1', label: 'Da' },
        { value: '2', label: 'Ne' },
      ]}
      value={seznam.parameter(ime) ?? '0'}
      onChange={(v) => seznam.nastavi({ [ime]: v === '0' ? null : v })}
      allowDeselect={false}
      w={{ base: 'calc(50% - 6px)', sm: 140 }}
    />
  );
}
